import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isAlwaysVisible = TiptapContentResolver.create(() => {
  return true;
});
export {
  isAlwaysVisible
};
//# sourceMappingURL=is-always-visible.js.map
